import { ShopifyTenantSettingsResponse } from "../../services/SettingService";
import { ActionType } from "../types";

export const APPLY_TYPE = "APPLY";

export interface GlobalSettingsState {
    settings: ShopifyTenantSettingsResponse;
}

export const initialSettingsState: GlobalSettingsState = {
    settings: {
        pickupsRequireLoadCheck: false,
        deliveriesRequireChecklist: false,
        consignmentDefaults: {
            pickupPhotoRequired: false,
            deliveryPhotoRequired: false,
            deliverySignatureRequired: false
        }
    }
}

export const reducer = (state: GlobalSettingsState, action: ActionType) : GlobalSettingsState => {
    switch (action.type) {
        case APPLY_TYPE:
            return {
                settings: action.payload
            }

        default:
            return initialSettingsState;
    }
}
